export const ArrowReplyIcon = ({
  strokeColor = "var(--color-btn-primary-active)",
  className,
}: {
  className?: string;
  strokeColor?: string;
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <g id="fluent:arrow-reply-28-regular">
      <path
        id="Vector"
        d="M15.4026 19.312C15.2822 19.1915 15.2146 19.0281 15.2146 18.8577C15.2146 18.6874 15.2822 18.524 15.4026 18.4034L19.234 14.572H11.7854C6.69658 14.572 2.57116 10.4466 2.57116 5.35771C2.57116 5.18721 2.63889 5.0237 2.75944 4.90314C2.88 4.78258 3.04352 4.71485 3.21401 4.71485C3.38451 4.71485 3.54802 4.78258 3.66858 4.90314C3.78914 5.0237 3.85687 5.18721 3.85687 5.35771C3.85687 6.3989 4.06195 7.4299 4.4604 8.39184C4.85884 9.35378 5.44286 10.2278 6.1791 10.9641C6.91533 11.7003 7.78937 12.2843 8.75131 12.6828C9.71325 13.0812 10.7442 13.2863 11.7854 13.2863H19.234L15.4026 9.45485C15.3394 9.396 15.2888 9.32503 15.2536 9.24617C15.2185 9.16731 15.1996 9.08219 15.1981 8.99587C15.1966 8.90955 15.2124 8.82382 15.2448 8.74377C15.2771 8.66372 15.3252 8.59101 15.3863 8.52996C15.4473 8.46892 15.52 8.42079 15.6001 8.38846C15.6801 8.35613 15.7659 8.34025 15.8522 8.34177C15.9385 8.3433 16.0236 8.36219 16.1025 8.39732C16.1813 8.43246 16.2523 8.48312 16.3112 8.54628L21.2397 13.4749C21.3601 13.5954 21.4277 13.7588 21.4277 13.9291C21.4277 14.0995 21.3601 14.2629 21.2397 14.3834L16.3112 19.312C16.1906 19.4324 16.0272 19.5 15.8569 19.5C15.6865 19.5 15.5231 19.4324 15.4026 19.312Z"
        fill={strokeColor}
      />
    </g>
  </svg>
);
